(function () {
  if (window.__dishwasherCartGuardPatched) return;
  window.__dishwasherCartGuardPatched = true;

  function getRole(item) {
    return item && item.properties && item.properties._bundle_role;
  }

  function getGroup(item) {
    return item && item.properties && item.properties._bundle_group;
  }

  async function getCartJson() {
    const res = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    return res.json();
  }

  async function removeByKey(key) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
  }

  function patchCart() {
    if (!window.cart || typeof window.cart.updateCart !== "function") return false;
    if (window.cart.__dishwasherGuardWrapped) return true;

    const originalUpdateCart = window.cart.updateCart.bind(window.cart);

    window.cart.updateCart = async function (payload, itemEl, valueIsEmpty) {
      try {
        if (!payload || payload.quantity !== 0 || !payload.id) {
          return originalUpdateCart(payload, itemEl, valueIsEmpty);
        }

        const cart = await getCartJson();
        const target = cart.items.find(function (i) {
          return i.key === payload.id;
        });

        if (!target) {
          return originalUpdateCart(payload, itemEl, valueIsEmpty);
        }

        const role = getRole(target);

        // Non-bundle items: default behavior
        if (role !== "main" && role !== "service") {
          return originalUpdateCart(payload, itemEl, valueIsEmpty);
        }

        if (role === "service") {
          const group = getGroup(target);
          const hasMain = cart.items.some(function (i) {
            return getGroup(i) === group && getRole(i) === "main";
          });

          // Normal lock: service can't be removed while main exists
          if (hasMain) {
            alert("This service is linked to the dishwasher and cannot be removed separately. Please remove the attached appliance to remove service.");
            return;
          }

          // Orphaned service (main missing): allow normal removal
          return originalUpdateCart(payload, itemEl, valueIsEmpty);
        }

        // Main dishwasher removed => remove linked service too
        const group = getGroup(target);
        const linkedService = cart.items.find(function (i) {
          return i.key !== target.key && getGroup(i) === group && getRole(i) === "service";
        });

        await removeByKey(target.key);
        if (linkedService) await removeByKey(linkedService.key);

        if (typeof window.cart.getCart === "function") {
          window.cart.getCart();
        } else {
          window.location.reload();
        }
      } catch (err) {
        console.error("dishwasher-cart-guard error", err);
        return originalUpdateCart(payload, itemEl, valueIsEmpty);
      }
    };

    window.cart.__dishwasherGuardWrapped = true;
    return true;
  }

  if (!patchCart()) {
    document.addEventListener("DOMContentLoaded", patchCart);
    setTimeout(patchCart, 500);
    setTimeout(patchCart, 1500);
  }
})();
